@if (stateConfigService.contingent && this.prices.length > 0) {
  <div class="flex flex-col w-full h-full overflow-x-hidden">
    <app-page-header>
      <div class="font-medium text-xl">Shop
        - {{ stateConfigService.selectedOrganisation ? stateConfigService.selectedOrganisation.name : "Persönlich" }}
      </div>
      <div class="rounded-lg flex flex-row justify-end items-center gap-4 h-10">
        <div [tooltip]="!activePrice ? 'Bitte erst ein Abo abschließen' : undefined" [tooltipDirection]="'bottom'">
          <bic-button (onClick)="showInfo = true" [disabled]="!activePrice" buttonType="white">
            <fa-icon [icon]="faExclamationCircle" iconLeft></fa-icon>
            Abo-Info
          </bic-button>
        </div>
        <div [tooltip]="!activePrice ? 'Bitte erst ein Abo abschließen' : undefined" [tooltipDirection]="'bottom'">
          <bic-button (onClick)="openCustomerPortal()" [disabled]="!activePrice" buttonType="primary">
            <fa-icon [icon]="faCartShopping" iconLeft></fa-icon>
            Zahlungen verwalten
          </bic-button>
        </div>
      </div>
    </app-page-header>
    <div
      class="flex flex-col w-full h-full items-center justify-start gap-8 p-4 main-sm:p-8 overflow-y-auto overflow-x-hidden">
      <div class="flex flex-col w-full items-center px-2 text-center">
        <h1 class="text-2xl main-sm:text-[36px] font-extrabold">planBIC - Preismodelle</h1>
        <p class="text-base main-sm:text-lg pt-4 pb-6 text-gray-500 font-normal">Das passende Abo-Modell für Ihr
          Bauvorhaben!</p>
        @if (stateConfigService.selectedOrganisation || stateConfigService.isPersonal) {
          <bic-toggle (valueChanged)="priceType = isYearly ? PriceType.MONTHLY : PriceType.YEARLY" [value]="isYearly">
            <div textLeft>Monatlich</div>
            <div textRight>Jährlich</div>
          </bic-toggle>
        }
      </div>
      <div class="flex flex-col main-xl:flex-row justify-center items-center main-xl:items-stretch w-full gap-8">
        @for (card of planCards; track card.key) {
          <app-shop-price-card (checkoutClicked)="checkout($event)"
                               [active]="card.price ? isActivated(card.price) : false"
                               [addOn]="card.price ? oneTimeBy(card.price) : null"
                               [isAddOn]="priceType == PriceType.ADDON"
                               [isSpecial]="card.price ? isSpecial(card.price) : false"
                               [price]="card.price"
                               [product]="card.product"
                                   [activePrice]="activePrice"
                                   class="w-full max-w-md">
          </app-shop-price-card>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="flex flex-col w-full h-full justify-center items-center">
    <app-cloud-number [loading]="true"></app-cloud-number>
  </div>
}

@if (activePrice) {
  <app-shop-info
    [(isOpen)]="showInfo"
    [activePrice]="activePrice"
    [activeProductSettings]="productSettingsBy(activePrice)!"
    [activeProduct]="activeProduct"
    [contingent]="stateConfigService.contingent"
    [isYearly]="activePrice.type == 'recurring' && activePrice.recurring?.interval == 'year'"
    [name]="activeAbonnementName"></app-shop-info>
}
